import app from 'flarum/forum/app';
import UserCard from 'flarum/forum/components/UserCard';

/**
 * Всплывающая карточка профиля при наведении — для блоков главной («Команда онлайн»,
 * «Сейчас на форуме», «Новый участник»), где данные приходят «плоскими» объектами.
 * Карточка — тот же UserCard, что и в сообщениях (плашки групп, обложка, звание),
 * но рисуется поверх страницы (position: fixed), чтобы её не обрезали блоки с overflow.
 */

const SHOW_DELAY = 280;
const HIDE_DELAY = 180;
let el = null;
let showTimer = null;
let hideTimer = null;
let token = 0;
let currentId = null;
function canHover() {
  return !(window.matchMedia && window.matchMedia('(hover: none)').matches);
}
function ensureEl() {
  if (el) return el;
  el = document.createElement('div');
  el.className = 'SlHoverCard';
  el.addEventListener('mouseenter', () => clearTimeout(hideTimer));
  el.addEventListener('mouseleave', scheduleHide);
  document.body.appendChild(el);

  // Уходим со страницы — карточка не должна остаться висеть.
  window.addEventListener('popstate', hideNow);
  window.addEventListener('scroll', hideNow, {
    passive: true
  });
  return el;
}
function hideNow() {
  clearTimeout(showTimer);
  clearTimeout(hideTimer);
  token++;
  currentId = null;
  if (el) {
    el.classList.remove('is-open');
    m.render(el, null);
  }
}
function scheduleHide() {
  clearTimeout(showTimer);
  token++;
  clearTimeout(hideTimer);
  hideTimer = setTimeout(hideNow, HIDE_DELAY);
}
function place(anchor) {
  const rect = anchor.getBoundingClientRect();
  const margin = 12;
  const width = el.offsetWidth;
  const height = el.offsetHeight;

  // Горизонталь: по левому краю якоря, но не за пределы экрана.
  let left = Math.min(rect.left, document.documentElement.clientWidth - width - margin);
  left = Math.max(margin, left);

  // Вертикаль: под якорем, а если не помещается — над ним.
  let top = rect.bottom + 6;
  if (top + height > window.innerHeight - margin && rect.top - height - 6 > margin) top = rect.top - height - 6;
  el.style.left = Math.round(left) + 'px';
  el.style.top = Math.round(Math.max(margin, top)) + 'px';
}
function open(anchor, data) {
  const id = String(data.id);
  clearTimeout(hideTimer);
  if (currentId === id && el && el.classList.contains('is-open')) return;
  const mine = ++token;

  // Берём настоящую модель пользователя: из кэша или с сервера (группы, обложка, звание).
  const cached = app.store.getById('users', id);
  const load = cached && cached.groups ? Promise.resolve(cached) : app.store.find('users', id);
  load.then(user => {
    if (mine !== token || !user || !document.body.contains(anchor)) return;
    ensureEl();
    currentId = id;
    m.render(el, m(UserCard, {
      user: user,
      className: "UserCard--popover",
      controlsButtonClassName: "Button Button--icon Button--flat"
    }));
    el.classList.add('is-open');
    place(anchor);
    // Картинки (обложка, аватар) меняют высоту — подправляем положение ещё раз.
    setTimeout(() => el.classList.contains('is-open') && mine === token && place(anchor), 120);
  }).catch(() => {});
}

/**
 * Атрибуты для ссылки/аватара: onmouseenter/onmouseleave, показывающие карточку.
 * @param data плоский объект пользователя из /api/sublace/overview (нужен только id)
 */
export function hoverAttrs(data) {
  if (!data || !data.id) return {};
  return {
    onmouseenter(e) {
      e.redraw = false;
      if (!canHover()) return;
      const anchor = e.currentTarget;
      clearTimeout(hideTimer);
      clearTimeout(showTimer);
      showTimer = setTimeout(() => open(anchor, data), SHOW_DELAY);
    },
    onmouseleave(e) {
      e.redraw = false;
      scheduleHide();
    },
    onclick() {
      hideNow();
    }
  };
}